export const reduxKey = '@@ResourceCache';
